import { memo, useMemo } from "react";
import { Box } from "@mui/material";
import PartHierarchyComponent from "./PartHierarchyComponent";
import { useTheme } from "../context/ThemeContext";

// Wrapped in React.memo so the whole parts tree is skipped on every live gizmo tick
function PartHierarchyWrapperComponent({
  partsHeight,
  selectedParts = [],
  modifiedPartIds = [],
  removedPartIds = [],
  visibilityModifiedPartIds = [],
  availableParts = [],
  partsHierarchyTree = [],
  handlePartsChange,
  removeSelectedPart,
}) {
  const { isDark } = useTheme();

  // A part pending removal (Reset) has an unsaved change too — same badge as a modified part.
  const combinedModifiedPartIds = useMemo(
    () => [
      ...(modifiedPartIds || []),
      ...(removedPartIds || []),
      ...(visibilityModifiedPartIds || []),
    ],
    [modifiedPartIds, removedPartIds, visibilityModifiedPartIds],
  );

  return (
    <Box
      sx={{
        backgroundColor: isDark ? "#1F2123" : "#F5F6F8",
        height: `${partsHeight}%`,
        minHeight: "20%",
        overflow: "auto",
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PartHierarchyComponent
        availableParts={availableParts}
        partsHierarchyTree={partsHierarchyTree}
        selectedParts={selectedParts}
        handlePartsChange={handlePartsChange}
        removeSelectedPart={removeSelectedPart}
        modifiedPartIds={combinedModifiedPartIds}
      />
    </Box>
  );
}

export default memo(PartHierarchyWrapperComponent);
